var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('CardSkeleton',{staticClass:"event-card"},[_c('LineSkeleton',{staticClass:"skeleton-line",attrs:{"width":"100%","height":"16px"}}),_c('LineSkeleton',{staticClass:"skeleton-line",attrs:{"width":"100%","height":"56px"}}),_c('LineSkeleton',{staticClass:"skeleton-line",attrs:{"width":"100%","height":"20px"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }